import React from 'react';
import PropTypes from 'prop-types';
import LocalizedDate from '../Localization/LocalizedDate';
import moment from 'moment';

ReviewCopyActionTooltip.propTypes = {
	headerText: PropTypes.string,
	createdDate: PropTypes.string,
	updatedDate: PropTypes.string,
};

function ReviewCopyActionTooltip({ headerText, createdDate, updatedDate }) {
	return (
		<>
			<div>{headerText}</div>
			{createdDate && renderDate('Added', createdDate)}
			{updatedDate &&
				!areSameDay(createdDate, updatedDate) &&
				renderDate('Updated', updatedDate)}
		</>
	);
}

const renderDate = (dateName, dateString) => {
	return (
		<div style={{ fontSize: 'smaller' }}>
			{dateName} <LocalizedDate dateString={dateString} />
		</div>
	);
};

const areSameDay = (date1, date2) => {
	return moment(date1)
		.startOf('day')
		.isSame(moment(date2).startOf('date'));
};

export default ReviewCopyActionTooltip;
